import Vue from 'vue'

Vue.filter('titleToSlug', (title) => {
  if (title) {
    return title.replace(/\ /g, '_').toLowerCase()
  }
  return title
})
